module.exports = __webpack_public_path__ + "static/media/sub-right.3c409aa3.svg";